import styled from "@emotion/styled";

interface EmptyContainerProps {
  children: React.ReactNode;
  dataTestId?: string;
}

export function EmptyContainer({ children, dataTestId }: EmptyContainerProps) {
  return <StyledContainer data-test-id={dataTestId}>{children}</StyledContainer>;
}

const StyledContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[4]};
  padding: ${({ theme }) => theme.spacing[2]};

  svg {
    max-width: 90vw;
    color: ${({ theme }) => theme.colors.background.illustration.default};
  }
`;
